import { gsap } from 'gsap/gsap-core'

export const init = (): void => {
    const elements = '[data-parallax]';

    if (window.innerWidth > 768) {
        document.querySelectorAll<HTMLElement>(elements).forEach((item: HTMLElement) => {
            const parallaxValue = item.dataset.parallax || '0';
            gsap.to(item, {
                yPercent: parseFloat(parallaxValue) * 100,
                ease: "none",
                scrollTrigger: {
                    trigger: item,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    // markers: true,
                },
            });
        });
    }
};
